/* Copyright (c) 2009 Mustafa OZCAN (http://www.mustafaozcan.net)
 * Released under the MIT license
 * Version: 1.0.3
 * Requires: jquery.1.3+
 */
jQuery.fn.fixedtableheader = function (options) {

    var settings = jQuery.extend({
        headerrowsize: 1,
        highlightrow: false,
        highlightclass: "highlight"
    }, options);

    this.each(function (i) {
        var $tbl = jQuery(this);
        var $tblhfixed = $tbl.find("tr:lt(" + settings.headerrowsize + ")");
        var headerelement = "th";
        if ($tblhfixed.find(headerelement).length == 0)
            headerelement = "td";
        if ($tblhfixed.find(headerelement).length > 0) {
            $tblhfixed.find(headerelement).each(function () {
                jQuery(this).css("width", jQuery(this).width());
            });
            var $clonedTable = $tbl.clone().empty();
            var tblwidth = GetTblWidth($tbl);
            $clonedTable.attr("id", "fixedtableheader" + i).css({
                "position": "fixed",
                "top": "0",
                "left": $tbl.offset().left
            }).append($tblhfixed.clone()).width(tblwidth).hide().appendTo(jQuery("body"));
            if (settings.highlightrow)
                jQuery("tr:gt(" + (settings.headerrowsize - 1) + ")", $tbl).hover(function () {
                    jQuery(this).addClass(settings.highlightclass);
                }, function () {
                    jQuery(this).removeClass(settings.highlightclass);
                });
            jQuery(window).scroll(function () {
                $clonedTable.css({
                    "position": "fixed",
                    "top": "0",
                    "left": $tbl.offset().left - jQuery(window).scrollLeft()
                });
                var sctop = jQuery(window).scrollTop();
                var elmtop = $tblhfixed.offset().top;
                if (sctop > elmtop && sctop <= (elmtop + $tbl.height() - $tblhfixed.height()))
                    $clonedTable.show();
                else
                    $clonedTable.hide();
            });
            jQuery(window).resize(function () {
                if ($clonedTable.outerWidth() != $tbl.outerWidth()) {
                    $tblhfixed.find(headerelement).each(function (index) {
                        var w = jQuery(this).width();
                        jQuery(this).css("width", w);
                        $clonedTable.find(headerelement).eq(index).css("width", w);
                    });
                    $clonedTable.width($tbl.outerWidth());
                }
                $clonedTable.css("left", $tbl.offset().left);
            });
        }
    });

    function GetTblWidth($tbl) {
        var tblwidth = $tbl.outerWidth();
        return tblwidth;
    }
};